import React from 'react';
import { Inquiries } from '../components/Inquiries';
import { FAQSection } from '../components/FAQSection';

export const Contact: React.FC = () => {
  return (
    <div className="pt-20">
      <Inquiries />
      <FAQSection />
    </div>
  );
};
